'use client';

import { useEffect, useState } from 'react';

import { DATADOG_USER_AGENT_REGEX } from './DatadogSyntheticUserAgent';

/**
 * Reports whether the current browser session is a Datadog Synthetic monitor.
 *
 * Reads `navigator.userAgent` only after mount, so it returns `false` during SSR and the
 * initial client render and then re-renders to the real value. Reading the user agent during
 * render instead would make the server and first client render disagree — a hydration mismatch
 * on any control (e.g. a submit button) gated on this value.
 *
 * Synthetic monitors can't solve the reCAPTCHA v2 checkbox, so callers use this to relax the
 * client-side token gate. The server still verifies the bypass via RecaptchaBypassService
 * (user agent AND bypass email), so a spoofed user agent alone cannot skip verification.
 */
export function useIsDatadogSynthetic(): boolean {
    const [isSynthetic, setIsSynthetic] = useState(false);

    useEffect(() => {
        setIsSynthetic(DATADOG_USER_AGENT_REGEX.test(navigator.userAgent));
    }, []);

    return isSynthetic;
}
